import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Attach Bearer token from localStorage as fallback (in case cookies get stripped)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("laka_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const endpoints = {
  authLogin: "/auth/login",
  authLogout: "/auth/logout",
  authMe: "/auth/me",
  publicServices: "/public/services",
  clients: "/clients",
  client: (id) => `/clients/${id}`,
  clientHistory: (id) => `/clients/${id}/history`,
  appointments: "/appointments",
  appointment: (id) => `/appointments/${id}`,
  services: "/services",
  plans: "/memberships/plans",
  membershipSummary: "/memberships/summary",
  professionals: "/config/professionals",
  rooms: "/config/rooms",
  payments: "/payments",
  metrics: "/dashboard/metrics",
  marketing: "/marketing/suggestions",
};
